<template>
  <div class="page">
    <PageHeader :links="headLinks" />
    <div class="pageMain"></div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"

export default {
  components: { PageHeader },
  data() {
    return {
      headLinks: [{ path: "", title: "管理首页" }],
    }
  },
}
</script>
